import React from "react";
import util from 'lodash/util';
import {PROJECT_ID} from '../firebaseApp';

import Button from "@material-ui/core/Button"
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import CaazamDevice from '../CaazamModel/CaazamDevice';
import withAuthorization from '../Session/withAuthorization';

import CaazamUser from '../CaazamModel/CaazamUser';
import Camera from '../Components/Camera';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import { iTunes, GooglePlay } from '../Constants/AppStores';

import { empty_avatar } from '../Constants/assets';

import GoogleAnalytics from '../Components/GoogleAnalytics';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit * 1,
    flexGrow: 1,
  },

  imageContainer : {
    height: 300,
    width: 300,
    justifyContent: 'center',
  },

  image: {    
    height: '100%',
    width: '100%', 
    borderRadius: 25,
    objectFit: 'cover',    
  },

  progressContainer : {
    //position: 'absolute',
    //left: 0, top: 0,
    //transform: 'translate(-50%, 0)',
  },

  progress : {

  },

  captureButton : {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    borderColor: theme.palette.primary.main,
  }
});

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.user = new CaazamUser(props.authUser);
    
    this.localStorageKey = {
      photoURL: PROJECT_ID.concat(`.${this.user.uid}`,'.profile.photoURL'),
    }

    this.state = { 
      isCameraOpen: false, 
      isCameraAllowed: CaazamDevice.hasMedia(), 
      profileImage: empty_avatar ,
      processing: false,
      completed: 0,
      processingError: null,
    };

    console.log((new CaazamDevice()).agent);
  }

  componentWillMount() {        
    const localUrl = localStorage.getItem(this.localStorageKey.photoURL);
    if (localUrl != null) {
      this.setState({ profileImage: localUrl });
    } 

    this.user.getProfileImage((url, error) => {
      if (error != null) {
        console.error('Profile:componentWillMount', error);
      } else if (url != null) {
        localStorage.setItem(this.localStorageKey.photoURL, url);
        this.setState({ profileImage: url });
      }
    })   
  }

  openCamera() {
    GoogleAnalytics.modalView('profile/camera');
    this.setState( {isCameraOpen: true} )
  }

  closeCamera() {
    this.setState( {isCameraOpen: false} )
  }

  newProfileCaptured(imgSrc) {
    this.prevProfileImage = this.state.profileImage;
    this.setState({isCameraOpen: false, profileImage: imgSrc, processing: true ,completed: 0});
    this.user.setProfileImage(
      imgSrc,
      (progress) => {
        this.setState({completed: progress});
        GoogleAnalytics.event(GoogleAnalytics.CATEGORY.user,GoogleAnalytics.CAAZAM_EVENTS.profilePhoto);
      },
      (error) => {       
        let newImage = error ?  this.prevProfileImage : this.state.profileImage;
        this.setState({processing: false, profileImage: newImage, completed: 100, processingError: error });
      });
  }

  render() {
    const { isCameraOpen, isCameraAllowed, profileImage, processing, completed} = this.state;
    const { classes } = this.props;
    const imageOpacity = processing ? 0.33 : 1.0;
    const progressVariant = completed > 0 ? 'static' : 'indeterminate';

    return (
      <div className={classes.root}>
        <Grid container spacing={8} direction='column' alignItems='center' justify='center' align="center">
          <Grid item>
            <Typography variant="title" >
              My Profile
            </Typography>
          </Grid>
          <Grid item className={classes.imageContainer}>
            <img src={profileImage} className={classes.image} style={{ opacity: imageOpacity }} alt='your profile' />            
          </Grid>
          <Grid item>
            {processing &&
              <div className={classes.progressContainer}>
                <Typography >Processing Photo</Typography>
                <CircularProgress className={classes.progress} variant={progressVariant} value={completed} />
              </div>
            }
            {!processing &&
              <div>
                <Button disabled={!isCameraAllowed} variant='outlined' color='primary' className={classes.captureButton} onClick={() => this.openCamera()}>Capture Caazam! Photo</Button>
                {!isCameraAllowed && this.renderNotSupported(classes)}
              </div>
            }
            {this.renderProcessingError(classes)}
            <Modal
              theme={this.props.theme}
              open={isCameraOpen}
              onClose={() => this.closeCamera()}
            >
              <Camera onCapture={(src) => this.newProfileCaptured(src)} onClose={() => this.closeCamera()} />
            </Modal>
          </Grid>
        </Grid>
      </div>
    );
  }

  handleErrorAlertClose = () => {
    this.setState({ processingError: null });
  };

  renderProcessingError(classes) {

    const errorCode = !!this.state.processingError ? `[${this.state.processingError.code}]` : "";
    var message = 'Something went wrong. Please try uploading your Caazam! selfie again';
    switch (errorCode) {
      case '[noFaces]':
        message = "No faces detected. Please try uploading your Caazam! selfie again";
        break;
      case '[tooManyFaces]':
        message = "More than one face detected. Please try uploading your Caazam! selfie again";
        break;
      default:
        break;
    }

    return (
      <Dialog
        open={!!this.state.processingError}
        onClose={this.handleErrorAlertClose}
        aria-labelledby="processing-alert-dialog-title"
        aria-describedby="processing-alert-dialog-description"
      >
        <DialogContent>
        <DialogTitle id="processing-alert-dialog-title">{"Caazam! Photo"}</DialogTitle>
          <DialogContentText id="alert-dialog-description">
            {message}. {errorCode}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleErrorAlertClose} >
            OK
        </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderNotSupported(classes) {
    var showiTunes = iTunes;
    var showGoogle = GooglePlay;
    var message = "To continue, please download the Caazam! App for your device"
    if (CaazamDevice.isApple()) {
      showGoogle = null;
      message = "To continue, please download the Caazam! App from the App Store"
    } else if (CaazamDevice.isAndroid()) {
      showiTunes = null;
      message = "To continue, please download the Caazam! App from Google Play"
    }

    return (
      <div>
        <Typography>This device can't catpure Caazam! Photos.</Typography>
        <Typography gutterBottom>{message}</Typography>
        {showiTunes && showiTunes()}
        {showGoogle && showGoogle()}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;

var enhance = util.flowRight(
  withAuthorization(authCondition),
  withStyles(styles)
);

export default enhance(Profile);



// WEBPACK FOOTER //
// ./src/CaazamApp/Profile.js